import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    connect() {

    }


    toggleClamp(event:MouseEvent) {
        event.preventDefault();
        const article =  (event.target as HTMLElement).parentElement.parentElement.parentElement
        const ele = article.querySelector(".overflow-ellipsis")
        const read_article = article.querySelector(".read-article")
        if (ele.classList.contains('line-clamp-3')) {
            ele.classList.remove('line-clamp-3')
            read_article.classList.add('hidden')
        } else{
            ele.classList.add('line-clamp-3')
            read_article.classList.remove('hidden')
        }
    }

}
